import React, { useEffect } from 'react'
import { MoneyManagementHeader, StoryBox, RightSection, LeftSection, MoneyManagementTextSection, MoneyManagementWrapper,TextBox, MoneyManagementTextHeader, MoneyManagementGridBox } from './MoneyManagement.styles'

export const MoneyManagement = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  
  return (
    <MoneyManagementWrapper>
      <MoneyManagementHeader>
        <LeftSection>
          <h3>
              Master your finances and achieve that good living you truly deserve
          </h3>
          {/* <NavLink to = "/">
              Start Saving
          </NavLink> */}
        </LeftSection>
        <RightSection>
            <img src="img/rafiki.png" alt="" />
        </RightSection>
      </MoneyManagementHeader>
      <MoneyManagementTextSection>
        <MoneyManagementTextHeader>Money management</MoneyManagementTextHeader>
        <TextBox>
          <p>The mind set you have towards money is very critical and matters a lot, to understand money demands that you understand some money concepts and apply them to the financial situations you face on a daily basis, you can live that dream life of Affluence you have always envisioned no matter what you earn</p>
          <p>To begin your journey to a financially independent life you must understand the money concept of assessing your finances, tracking your spending, making a better financial choices and using a smart budget to manage your expenses.</p>
        </TextBox>
      </MoneyManagementTextSection>

      <>

      <MoneyManagementTextHeader>Steps to making a smart budget and putting money concepts into use</MoneyManagementTextHeader>
      <MoneyManagementGridBox>
        <StoryBox>
          <div>1</div>
          <p>
              Know what you earn and how much you spend randomly, 
              do your accurate analysis by becoming aware of your spending spree, 
              list out what you spend money on to move away from unnecessary
              impulsive spending into a more conscious spending
          </p>
        </StoryBox>
        <StoryBox>
          <div>2</div>
          <p>
              Categorize your spending some expenses are just way more 
              important than others, settle your top priority expenses 
              ,those that have to do with survival like food, medical 
              bills, electricity bills etc. and some that have to do with
              our daily activities like clothing, groceries, transport 
              fare etc. know how much you spend on these stuffs and when 
              you are required to spend on them, once you do all that 
              accurately, then you know what’s really going on with your 
              money and that’s a very powerful advantage over your finances
          </p>
        </StoryBox>
        <StoryBox>
          <div>3</div>
          <p>
              Now, if you have got enough money to survive and some to spend 
              on the necessary stuffs then decide where to cut back on your 
              expenses and create a budget for your next spending because
              the first step to financial freedom is to spend less than you 
              earn. You then protect and improve your financial status by 
              cultivating a saving discipline with the rest of your money 
              and eventually get to the point where you can start accruing 
              well meaning investments with your saved funds and watch your money
               grows as you build your wealth.
          </p>
        </StoryBox>
      </MoneyManagementGridBox>
      </>
        
    </MoneyManagementWrapper>
  )
}
